import {
    // Page, 
    Text,
    View,
    Image
} from '@react-pdf/renderer';

import { styles } from '../styles/styles';

// for delivery order
// export function BodyMainHeaderStyle1(props) {

//     return (
//         <View
//             style={{
//                 display: 'flex',
//                 flexDirection: 'row',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 // paddingVertical: 8,
//                 paddingTop: 10,
//                 paddingBottom: 3,
//                 borderBottomColor: '#000',
//                 borderBottomStyle: 'solid',
//                 borderBottomWidth: 0.5,
//             }}
//         >
//             <View style={{ width: '5%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
//             </View>
//             <View style={{ width: '20%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Item</Text>
//             </View>
//             <View style={{ width: '25%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Description</Text>
//             </View>
//             <View style={{ width: '22%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase, styles.textAlignRight]}>Dimension (LxWxH)</Text>
//             </View>
//             <View style={{ width: '8%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase, styles.textAlignRight]}>Qty</Text>
//             </View>
//             <View style={{ width: '8%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase, styles.textAlignRight]}>CBM</Text>
//             </View>
//             <View style={{ width: '8%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase, styles.textAlignRight]}>Weight</Text>
//             </View>
//             {/* {
//                 tableFields.map((i, index) => {
//                     return (
//                         <View 
//                             key={index}
//                             style={{
//                                 width: i.width,
//                                 textAlign: i?.align? i.align: '',
//                                 fontWeight: 800
//                             }}
//                         >
//                             <Text style={[styles.h8, styles.weight, { } ]}>{i.display.toUpperCase()}</Text>
//                         </View>
//                     )
//                 })
//             } */}
//         </View>
//     )

// }

// export function BodyMainHeaderStyle2(props) {
//     return (
//         <View
//             style={{
//                 display: 'flex',
//                 flexDirection: 'row',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 // paddingVertical: 8,
//                 paddingTop: 10,
//                 paddingBottom: 3,
//                 borderBottomColor: '#000',
//                 borderBottomStyle: 'solid',
//                 borderBottomWidth: 0.5,
//             }}
//         >
//             <View style={{ width: '5%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
//             </View>
//             <View style={{ width: '13%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Code</Text>
//             </View>
//             <View style={{ width: '25%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Name</Text>
//             </View>
//             <View style={{ width: '8%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>UOM</Text>
//             </View>
//             <View style={{ width: '8%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Qty</Text>
//             </View>
//             <View style={{ width: '39%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Instructions</Text>
//             </View>
//             {/* {
//                 tableFields.map((i, index) => {
//                     return (
//                         <View 
//                             key={index}
//                             style={{
//                                 width: i.width,
//                                 textAlign: i?.align? i.align: '',
//                                 fontWeight: 800
//                             }}
//                         >
//                             <Text style={[styles.h8, styles.weight, { } ]}>{i.display.toUpperCase()}</Text>
//                         </View>
//                     )
//                 })
//             } */}
//         </View>
//     )
// }

// for sales invoice
// export function BodyMainHeaderStyle3(props) {

//     return (
//         <View
//             style={{
//                 display: 'flex',
//                 flexDirection: 'row',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 // paddingVertical: 8,
//                 paddingTop: 10,
//                 paddingBottom: 3,
//                 borderBottomColor: '#000',
//                 borderBottomStyle: 'solid',
//                 borderBottomWidth: 0.5,
//             }}
//         >
//             <View style={{ width: '5%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>No.</Text>
//             </View>
//             <View style={{ width: '15%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Code</Text>
//             </View>
//             {/* <View style={{ width: '20%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Name</Text>
//             </View> */}
//             <View style={{ width: '29%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase]}>Description</Text>
//             </View>
//             <View style={{ width: '8%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textUpperCase, styles.textAlignRight]}>Qty</Text>
//             </View>
//             <View style={{ width: '11%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textAlignRight, styles.textUpperCase]}>Price</Text>
//             </View>
//             <View style={{ width: '11%' }}>
//                 <Text style={[styles.h9, styles.textBold, styles.textAlignRight, styles.textUpperCase]}>Total</Text>
//             </View>
//         </View>
//     )

// }

// for product label
export function BodyMainHeaderStyle4(props) {

    const { isEnd = false, data1 = {}, data2 = {} } = props

    let barcodeDataUrl = data1?.barcodeDataUrl ? data1.barcodeDataUrl : '/assets/images/customization/sdgrouphub/logoLabel.jpg'

    // console.log('data', data1, barcodeDataUrl)

    const LeftBox = ({ isEnd = false, title = '', value = '' }) => {
        return (
            <View
                style={{
                    height: '50%',
                    ...(isEnd === true &&
                    {

                        borderBottomWidth: 1,
                        borderColor: '#000',
                        borderStyle: 'solid',
                    })
                }}
            >
                <Text style={[styles.normalTextFamilyCN, { marginTop: 5, marginRight: 5, fontSize: 7, textAlign: 'right' }]}>{title}</Text>
                <Text style={[styles.boldTextFamilyCN, { paddingLeft: 5, marginTop: 5, fontSize: 12 }]}>{value}</Text>
            </View>
        )
    }

    const RemarkBox = ({ title = '', value = '', footerText = '' }) => {

        let _value = ''

        if (value) {
            _value = value.replace(/\n/g, "");
        } else {
            _value = `-`
        }

        return (
            <View
                style={{
                    width: '100%',
                    // width: 100,
                    height: '100%',
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    flexWrap: true,
                    // backgroundColor: 'red',
                }}
            >
                <View>
                    <Text style={[styles.normalTextFamilyCN, { marginRight: 0, fontSize: 7, textAlign: 'right', width: "100%" }]}>{title}</Text>
                    <Text style={[styles.boldTextFamilyCN, { marginTop: 5, fontSize: 10 }]}>{_value}</Text>
                </View>
                {
                    footerText && (
                        <View
                            style={{
                                marginTop: 5,
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                alignItems: "flex-start"
                            }}
                        >
                            <Text style={[styles.normalTextFamilyCN, { marginRight: 5, fontSize: 7 }]}>快递:</Text>
                            <Text style={[styles.normalTextFamilyCN, { fontSize: 7 }]}>{footerText}</Text>
                        </View>

                    )
                }
            </View >
        )
    }

    return (
        <View
            style={{
                height: 60,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                // paddingVertical: 8,
                // paddingTop: 10,
                // paddingBottom: 3,
                // borderBottomColor: '#000',
                // borderBottomStyle: 'solid',
                // borderBottomWidth: 0.5,

                borderWidth: 1,
                borderColor: '#000',
                borderStyle: 'solid',
                borderTopWidth: 0,
                borderLeftWidth: 0,
                borderRightWidth: 0,

                ...(isEnd === true && { borderBottomWidth: 0 })
            }}
        >
            <View
                style={{
                    // backgroundColor: 'red',
                    // borderWidth: 1,
                    // borderColor: '#000',
                    // borderStyle: 'solid',
                    width: "50%",
                    height: "100%",

                    borderRightWidth: 1,
                    borderColor: '#000',
                    borderStyle: 'solid',
                    // display: "flex",
                    // flexDirection: "column",
                    // justifyContent: 'flex-end',
                    // alignItems: 'flex-start'
                }}
            >
                {
                    isEnd === false ?
                        (
                            <>
                                <LeftBox
                                    isEnd
                                    title={`采购订单号 P/O No.`}
                                    value={`${data1?.companyPoNo}`}
                                />
                                <LeftBox
                                    isEnd={false}
                                    title={`厂家采购单号 Supplier P/O No.`}
                                    value={`${data1?.supplierPoNo}`}
                                />
                            </>
                        )
                        :
                        (
                            <>
                                <LeftBox
                                    isEnd
                                    title={`签收人 Received By`}
                                    value={`${data2?.receivedBy}`}
                                />
                                <LeftBox
                                    isEnd={false}
                                    title={`数量 Qty`}
                                    value={`${data2?.qty}`}
                                />
                            </>
                        )
                }


            </View>
            <View
                style={{
                    padding: 5,
                    width: "50%",
                    height: "100%",

                    // borderWidth: 1,
                    // borderColor: '#000',
                    // borderStyle: 'solid',
                }}
            >
                {
                    isEnd === false ?
                        (
                            <View
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: 'center',
                                    justifyContent: "center"
                                }}
                            >
                                <Image
                                    src={barcodeDataUrl}
                                    style={{
                                        width: '120',
                                        height: '50'
                                    }}
                                />
                                <Text style={[styles.boldTextFamilyCN, { fontSize: 9 }]}>{data1?.barcodeText}</Text>
                            </View>
                        )
                        :
                        (
                            <RemarkBox
                                isEnd={false}
                                title={`备注 Remark`}
                                value={`${data2?.remark}`}
                                footerText={`${data2?.courierText}`}
                            />
                        )
                }
            </View>
        </View>
    )
}